// extracted by mini-css-extract-plugin
export default {"navbarFixed":"navbar_navbarFixed__FpUs1","navCenter":"navbar_navCenter__CHrSL","navbarnav":"navbar_navbarnav__Emm7Z","navlink":"navbar_navlink__Dk42R","chat":"navbar_chat__dD07n"};